import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getBusinessNameAndAddress from 'utils/print/getBusinessNameAndAddress';
import getFacilityNameAndAddress from 'utils/print/getFacilityNameAndAddress';
import getSignature from 'utils/print/getSignature';

const HIPAAFormRequest = {
  ID: 27,
  Name: 'HIPAA Form Request',
  Type: 'Assessment Form',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/HIPAA-Form-Request/1.js',
      fields: [
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 15,
          y: 38.5,
          width: 83,
        },
        {
          name: 'Patient DOB',
          type: 'text',
          getValue: getPatientFullDob,
          normalize: normalize.date,
          x: 103,
          y: 38.5,
          width: 34,
        },
        {
          name: 'Patient Identification Number',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 142,
          y: 38.5,
          width: 59,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: getPatientFullAddress,
          x: 15,
          y: 47,
          width: 186,
        },
        {
          name: 'Name and Address of Provider or Entity to Release this Information',
          type: 'text',
          getValue: props => getFacilityNameAndAddress(props) || getBusinessNameAndAddress(props),
          x: 15,
          y: 110,
          width: 186,
        },
        {
          name: 'Name and Address of Person(s) to Whom this Information Will Be Disclosed',
          type: 'text',
          x: 15,
          y: 122.5,
          width: 186,
        },
        {
          name: 'Purpose for Release of Information',
          type: 'text',
          x: 15,
          y: 131,
          width: 186,
        },
        {
          name: 'INSERT START DATE',
          type: 'text',
          x: 121,
          y: 138.5,
          width: 32,
          normalize: normalize.date,
        },
        {
          name: 'INSERT EXPIRATION DATE OR EVENT',
          type: 'text',
          x: 166,
          y: 138.5,
          width: 32,
        },
        {
          name: 'All health information (written and oral)',
          type: 'checkbox',
          x: 17,
          y: 147,
          width: 3,
          height: 3,
        },
        {
          name: 'All health information (written and oral) except',
          type: 'text',
          x: 17,
          y: 153,
          width: 184,
        },
        {
          name: 'Records from alcohol/drug treatment programs',
          type: 'checkbox',
          x: 17,
          y: 169,
          width: 3,
          height: 3,
        },
        {
          name: 'Records from alcohol/drug treatment programs Information to be Disclosed',
          type: 'text',
          x: 83,
          y: 169,
          width: 98,
        },
        {
          name: 'Records from alcohol/drug treatment programs Initials',
          type: 'text',
          x: 183,
          y: 169,
          width: 20,
        },
        {
          name: 'Clinical records from mental health programs',
          type: 'checkbox',
          x: 17,
          y: 177,
          width: 3,
          height: 3,
        },
        {
          name: 'Clinical records from mental health programs Information to be Disclosed',
          type: 'text',
          x: 83,
          y: 175,
          width: 98,
        },
        {
          name: 'Clinical records from mental health programs Initials',
          type: 'text',
          x: 183,
          y: 175,
          width: 20,
        },
        {
          name: 'HIV/AIDS­related Information',
          type: 'checkbox',
          x: 17,
          y: 183,
          width: 3,
          height: 3,
        },
        {
          name: 'HIV/AIDS­related Information Information to be Disclosed',
          type: 'text',
          x: 83,
          y: 183,
          width: 98,
        },
        {
          name: 'HIV/AIDS­related Information Initials',
          type: 'text',
          x: 183,
          y: 183,
          width: 20,
        },
        {
          name: 'If not the patient , name of person signing form',
          type: 'text',
          x: 17,
          y: 195,
          width: 90,
        },
        {
          name: 'Authority to sign on behalf of patient',
          type: 'text',
          x: 110,
          y: 195,
          width: 90,
        },
        {
          name: 'SIGNATURE OF PATIENT OR REPRESENTATIVE AUTHORIZED BY LAW',
          type: 'signature',
          getValue: getSignature,
          x: 18,
          y: 207,
          width: 60,
          height: 8,
        },
        {
          name: 'SIGNATURE OF PATIENT OR REPRESENTATIVE AUTHORIZED BY LAW DATE',
          type: 'text',
          x: 180,
          y: 209,
          width: 24,
          normalize: normalize.date,
        },
        {
          name: 'STAFF PERSON’S NAME AND TITLE',
          type: 'text',
          x: 20,
          y: 228,
          width: 80,
        },
        {
          name: 'STAFF PERSON’S NAME AND TITLE Signature',
          type: 'signature',
          x: 104,
          y: 221,
          width: 60,
          height: 10,
        },
        {
          name: 'STAFF PERSON’S NAME AND TITLE DATE',
          type: 'text',
          x: 180,
          y: 228,
          width: 24,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default HIPAAFormRequest;



// WEBPACK FOOTER //
// ./src/config/documents/HIPAA-Form-Request.js